// test2923
(2923 && 0);
